const TOUR_ACTIVE_CLASS = 'onboarding-tour-target';

const buildOverlay = () => {
  const overlay = document.createElement('div');
  overlay.className = 'onboarding-tour-overlay';
  return overlay;
};

const buildTooltip = (title, body, stepIndex, totalSteps) => {
  const tooltip = document.createElement('div');
  tooltip.className = 'onboarding-tour-tooltip';
  tooltip.innerHTML = `
    <div class="onboarding-tour-title">${title}</div>
    <div class="onboarding-tour-body">${body}</div>
    <div class="onboarding-tour-footer">
      <div class="onboarding-tour-counter">${stepIndex + 1}/${totalSteps}</div>
      <div class="onboarding-tour-buttons">
        <button type="button" class="ui tiny button onboarding-tour-back">戻る</button>
        <button type="button" class="ui tiny primary button onboarding-tour-next">次へ</button>
      </div>
    </div>
  `;
  return tooltip;
};

const positionTooltip = (tooltip, target, position) => {
  const margin = 12;
  const rect = target.getBoundingClientRect();
  const tooltipRect = tooltip.getBoundingClientRect();

  let top = 0;
  let left = 0;
  const fallback = position || 'bottom';

  const place = (pos) => {
    if (pos === 'top') {
      top = rect.top - tooltipRect.height - margin;
      left = rect.left;
    } else if (pos === 'right') {
      top = rect.top;
      left = rect.right + margin;
    } else if (pos === 'left') {
      top = rect.top;
      left = rect.left - tooltipRect.width - margin;
    } else {
      top = rect.bottom + margin;
      left = rect.left;
    }
  };

  place(fallback);

  if (top < margin) {
    place('bottom');
  }
  if (left < margin) {
    left = margin;
  }
  if (left + tooltipRect.width > window.innerWidth - margin) {
    left = window.innerWidth - tooltipRect.width - margin;
  }
  if (top + tooltipRect.height > window.innerHeight - margin) {
    place('top');
  }
  if (top < margin) {
    top = margin;
  }

  tooltip.style.top = `${top + window.scrollY}px`;
  tooltip.style.left = `${left + window.scrollX}px`;
};

const clearTourArtifacts = () => {
  document.querySelectorAll(`.${TOUR_ACTIVE_CLASS}`).forEach((node) => {
    node.classList.remove(TOUR_ACTIVE_CLASS);
  });
  document.querySelectorAll('.onboarding-tour-overlay, .onboarding-tour-tooltip').forEach((node) => {
    node.remove();
  });
};

const runTour = (tourId) => {
  const steps = Array.from(document.querySelectorAll(`[data-tour="${tourId}"][data-tour-step]`))
    .sort((a, b) => Number(a.dataset.tourStep) - Number(b.dataset.tourStep));

  if (steps.length === 0) {
    return;
  }

  let currentIndex = 0;

  const endTour = () => {
    clearTourArtifacts();
    document.removeEventListener('keydown', handleKey);
  };

  const showStep = () => {
    clearTourArtifacts();
    const step = steps[currentIndex];
    step.classList.add(TOUR_ACTIVE_CLASS);
    step.scrollIntoView({ block: 'center', behavior: 'smooth' });

    const title = step.dataset.tourTitle || 'ガイド';
    const body = step.dataset.tourBody || '';
    const tooltip = buildTooltip(title, body, currentIndex, steps.length);
    const overlay = buildOverlay();

    document.body.appendChild(overlay);
    document.body.appendChild(tooltip);

    const nextButton = tooltip.querySelector('.onboarding-tour-next');
    const backButton = tooltip.querySelector('.onboarding-tour-back');

    if (currentIndex === 0) {
      backButton.disabled = true;
    }
    if (currentIndex === steps.length - 1) {
      nextButton.textContent = '完了';
    }

    const position = step.dataset.tourPosition;
    positionTooltip(tooltip, step, position);

    overlay.addEventListener('click', endTour, { once: true });
    nextButton.addEventListener('click', () => {
      if (currentIndex === steps.length - 1) {
        endTour();
        return;
      }
      currentIndex += 1;
      showStep();
    });
    backButton.addEventListener('click', () => {
      if (currentIndex === 0) {
        return;
      }
      currentIndex -= 1;
      showStep();
    });
  };

  const handleKey = (event) => {
    if (event.key === 'Escape') {
      endTour();
    }
  };

  document.addEventListener('keydown', handleKey);
  showStep();
};

document.addEventListener('turbolinks:load', () => {
  clearTourArtifacts();
  document.querySelectorAll('[data-tour-start]').forEach((button) => {
    if (button.dataset.tourBound === 'true') {
      return;
    }
    button.dataset.tourBound = 'true';
    button.addEventListener('click', () => {
      const tourId = button.dataset.tourStart;
      runTour(tourId);
    });
  });
});
